// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"Checkbox_mainContainer__1BI2o"};